import { combineReducers } from 'redux';
import { authentication } from "./authentication";
import { company } from './company';
import { order } from './order';
import { product } from './product';
import { customer } from './customer';
import { store } from './store';
import { general } from './general';
// import storage from "redux-persist/lib/storage";

const appReducer = combineReducers({
  authentication: authentication,
  order: order,
  company: company,
  product: product,
  customer: customer,
  store: store,
  general: general
});

export const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT') {
    // document.documentElement.setAttribute('theme', "light");
    // storage.removeItem('persist:authentication');
    state = { company: { urlIdentifier: state.company.urlIdentifier }};
  }
  return appReducer(state, action)
}